import { useCartItem } from '@/context/CartItemContext'
import { useCart } from 'hooks/graphql/legacy-api'
import { useMemo } from 'react'

import { formatCost, formatNumbers } from 'utils'

export default function CartItemBalance() {
	const { cart } = useCart()
	const { cartItemTotalPrice, cartItemTotalPriceWithoutRushFee, taxWithRushFee, cartItemQuantity } =
		useCartItem()

	const rushFee = useMemo(() => {
		if (cartItemTotalPrice - cartItemTotalPriceWithoutRushFee > 0) {
			return cartItemTotalPrice - cartItemTotalPriceWithoutRushFee
		}

		return 0
	}, [cartItemTotalPrice, cartItemTotalPriceWithoutRushFee])

	return (
		<li>
			<h3 className="card-head">Order total</h3>
			<div className="p-4 flex flex-col gap-2">
				<div className="flex justify-between">
					<div className="font-medium  text-sm">
						Subtotal ({formatNumbers(cartItemQuantity)} unit{cartItemQuantity > 1 ? 's' : ''})
					</div>

					<div className="font-medium">{formatCost(cartItemTotalPriceWithoutRushFee)}</div>
				</div>
				{rushFee > 0 && (
					<div className="flex justify-between">
						<div className="font-medium text-sm">Expedited turnaround</div>

						<div className="font-medium">{formatCost(rushFee)}</div>
					</div>
				)}
				<div className="flex justify-between">
					<div className="font-medium text-sm">Shipping</div>

					<div className="font-medium">Free shipping</div>
				</div>
				<div className="flex justify-between">
					<div className="font-medium text-sm">Tax</div>

					<div className="font-medium">
						{cart?.state ? formatCost(taxWithRushFee) : 'Determined at checkout'}
					</div>
				</div>
				<hr className="border-g-200 my-2" />
				<div className="flex justify-between">
					<div className="font-medium">Total</div>

					<div className="font-medium">{formatCost(cartItemTotalPrice + taxWithRushFee)}</div>
				</div>
			</div>
		</li>
	)
}
